import "./OrderSummary.css";

export default function SummaryRow({

    label,

    value,

    type = "normal",

}){

    return(

        <div className={`summary-row ${type}`}>

            <span>{label}</span>

            <span>{value}</span>

        </div>

    );

}